import FreeStarterImage from 'assets/images/freeStarter.png';

const FreeStarterOffer = () => (
  <img
    width="100%"
    height="fit-content"
    alt="Free starter"
    src={FreeStarterImage}
    style={{ maxHeight: '129px', maxWidth: '131px', minWidth: '60px', marginTop: '15px' }}
  />
);

export default FreeStarterOffer;
